<template>
  <div class="bt-anggota pa-5">
    <div class="d-flex justify-center align-center mb-5">
      <div class="credit-card">
        <div class="card-logo">Cash Inflow</div>
        <div class="chip">
          <img src="../assets/logo.png" alt="" />
        </div>
        <div>
          <div class="card-number">Rp. {{ thousand(totalDeposit) }}</div>
        </div>
        <v-chip small :color="sudahCetak ? 'green' : 'red'" dark class="status-chip">
          {{ sudahCetak ? 'Sudah cetak setoran' : 'Belum cetak setoran' }}
        </v-chip>
      </div>
    </div>
    <div class="mb-9">
      <v-card class="overflow-hidden elevation-3 rounded-lg mb-3">
        <v-card-text>
          <v-autocomplete label="Hari" class="mb-4" hide-details :items="opt_hari" item-text="day_name"
            item-value="day_code" v-model="selectedItem" />
          <v-menu ref="menu" v-model="dateShow" :close-on-content-click="false" :return-value.sync="transaction_date"
            transition="scale-transition" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="transaction_date" label="Tanggal" readonly v-bind="attrs" v-on="on" />
            </template>
            <v-date-picker v-model="transaction_date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateShow = false"> Cancel </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(transaction_date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>
      </v-card>
      <div class="my-4" v-if="rembug.length > 0">
        <v-btn block class="btn-cetak-full" @click="sheetCetak = true" elevation="0" :hidden="sudahCetak">
          <v-icon left size="18">mdi-printer</v-icon>
          Cetak Setoran
        </v-btn>
      </div>
      <v-card v-for="(rbg, rbgIndex) in rembug" :key="rbgIndex" class="card-modern mb-4">
        <v-row>
          <!-- HEADER -->
          <v-col cols="7">
            <div class="d-flex align-center">
              <div class="text-uppercase text-lg font-weight-bold">
                Kp. {{ rbg.cm_name }}
              </div>
            </div>
            <div>
              <span class="text-caption grey--text">
                {{ rbg.desa }}
              </span>
            </div>
            <!-- CONTENT -->
          </v-col>
          <v-col cols="5" class="text-right">
            <div class="d-flex justify-end">
              <span class="text-caption grey--text">
                Total Setor
              </span>
            </div>
            <div>
              <span class="anggota-count text-lg font-weight-bold" :class="{ 'red--text': rbg.total_setor < 0 }">
                Rp{{ thousand(rbg.total_setor) }}
              </span>
            </div>
          </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
        <v-btn block class="btn-modern" type="button" @click="checkExisting(rbg.cm_code, rbg.cm_name)"
          :loading="loadingBtn === rbg.cm_code" :disabled="!sudahCetak || loadingBtn !== null">
          <span class="mr-2">Kirim Data</span>
        </v-btn>
      </v-card>
      <div v-if="rembug.length === 0" class="text-center mt-9">
        <v-icon large color="grey lighten-4">mdi-database-off</v-icon>
        <p class="mt-5 grey--text text--lighten-4">
          Tidak ada data transaksi </br>
          pada hari <strong>{{ getDayName(selectedItem) }}</strong> dan tgl <strong>{{ transaction_date }}</strong>
        </p>
      </div>
      <!-- ======= 🔥 BOTTOM SHEET (TAMBAHAN) ======= -->
      <v-bottom-sheet v-model="sheetCetak" inset max-width="500px">
        <v-sheet class="sheet-modern">

          <!-- HEADER -->
          <div class="sheet-header">
            <div class="title">Preview Setoran</div>
            <v-btn icon small @click="sheetCetak = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <v-divider></v-divider>

          <!-- LIST -->
          <div class="sheet-content">

            <div v-for="(item, i) in rembug" :key="i" class="list-row" :class="{ zebra: i % 2 === 1 }">
              <div class="left">
                {{ i + 1 }}. {{ item.cm_name }}
              </div>
              <div class="right">
                Rp {{ thousand(item.total_setor) }}
              </div>
            </div>

            <!-- TOTAL -->
            <div class="total-box">
              <strong>Total</strong>
              <strong>Rp {{ thousand(totalDeposit) }}</strong>
            </div>

            <!-- SIGNATURE -->
            <div class="signature-box">
              <div class="label">Tanda Tangan Petugas</div>

              <div class="signature-container">
                <VueSignaturePad ref="signaturePad" width="100%" height="180px" :options="signatureOptions" />
              </div>

              <v-btn small text color="grey" @click="clearSignature">
                Hapus Tanda Tangan
              </v-btn>
            </div>

          </div>

          <!-- ACTION -->
          <div class="sheet-action">
            <v-btn block class="btn-modern " @click="generatePDF" :disabled="!isSigned">
              Simpan PDF
            </v-btn>
          </div>

        </v-sheet>
      </v-bottom-sheet>
    </div>
  </div>
</template>


<script>
import logo from "@/assets/logo.png";
import Header from "@/components/Header";
import Toast from "@/components/Toast";
import services from "@/services";
import helper from "@/utils/helper";
import { jsPDF } from "jspdf";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Send",
  components: {
    Toast,
    Header,
  },
  data() {
    return {
      loadingBtn: null,
      rembug: [],
      selectedItem: this.getTodayDay(),
      transaction_date: this.getDate(),
      totalDeposit: 0,
      dateShow: false,

      sheetCetak: false,
      sudahCetak: false,
      isSigned: false,
      signature: null,
      signatureOptions: {
        penColor: "#000000"
      },

      opt_hari: [
        {
          day_name: "Senin",
          day_code: 1,
        },
        {
          day_name: "Selasa",
          day_code: 2,
        },
        {
          day_name: "Rabu",
          day_code: 3,
        },
        {
          day_name: "Kamis",
          day_code: 4,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    isLoading() {
      return this.$store.state.isLoading;
    }
  },
  methods: {
    ...helper,
    ...mapActions(["logout", "setKasPetugas"]),
    startDetect() {
      this.interval = setInterval(() => {
        if (!this.$refs.signaturePad) return;

        const res = this.$refs.signaturePad.saveSignature();

        const hasSign = !!(res && res.data);

        if (hasSign !== this.isSigned) {
          this.isSigned = hasSign;
        }
      }, 800);
    },

    stopDetect() {
      clearInterval(this.interval);
      this.interval = null;
    },

    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.isSigned = false;
    },

    async getBase64FromUrl(url) {
      const res = await fetch(url);
      const blob = await res.blob();

      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },

    async generatePDF() {

      const result = this.$refs.signaturePad.saveSignature();

      if (!result || !result.data) {
        alert("Silakan tanda tangan dulu");
        return;
      }

      this.signature = result.data;

      const img = new Image();
      img.src = logo;
      await new Promise((resolve) => (img.onload = resolve));

      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const margin = 15;
      const contentWidth = pageWidth - margin * 2;
      const rightX = margin + contentWidth;

      let y = 15;

      const trx_code = `TRX-${Date.now()}`;

      const tanggal = new Date().toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      // ================= WATERMARK =================
      const drawWatermark = () => {
        doc.setGState(new doc.GState({ opacity: 0.05 }));
        doc.addImage(
          img,
          "PNG",
          (pageWidth - 100) / 2,
          (pageHeight - 100) / 2,
          100,
          100
        );
        doc.setGState(new doc.GState({ opacity: 1 }));
      };

      // ================= HEADER =================
      const drawHeader = () => {
        y = 15;

        doc.addImage(img, "PNG", margin, 10, 16, 16);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text("KSPPS Abdi Kerta Raharja", margin + 22, 14);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text("Bukti Setoran", margin + 22, 19);
        doc.text("Transaksi DTL Online", margin + 22, 24);

        doc.text(`TRX: ${trx_code}`, rightX, 14, { align: "right" });
        doc.text(tanggal, rightX, 19, { align: "right" });

        doc.setDrawColor(200);
        doc.line(margin, 30, rightX, 30);

        y = 35;
      };

      // ================= INIT =================
      drawWatermark();
      drawHeader();

      // ================= INFO =================
      // ================= INFO BOX =================
      const drawInfoBox = () => {

        // 🔥 TANPA BOX
        // (hapus doc.rect)

        // 🔥 GRID PRESISI (SEJAJAR DENGAN TABLE)
        const labelX = margin;        // sejajar dengan NO
        const colonX = margin + 22;   // titik dua konsisten
        const valueX = margin + 25;   // isi sejajar

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");

        // CABANG
        doc.text("CABANG", labelX, y + 5);
        doc.text(":", colonX, y + 5);
        doc.text(
          (this.user?.branch_name || "-").toUpperCase(),
          valueX,
          y + 5
        );

        // PETUGAS
        doc.text("PETUGAS", labelX, y + 10);
        doc.text(":", colonX, y + 10);
        doc.text(
          (this.user?.nama_user || "-").toUpperCase(),
          valueX,
          y + 10
        );

        y += 20;
      };
      drawInfoBox();

      // ================= TABLE HEADER =================
      doc.setFont("helvetica", "bold");

      doc.text("NO", margin, y);
      doc.text("KUMPULAN", margin + 25, y);
      doc.text("NOMINAL", rightX, y, { align: "right" });

      y += 2;

      doc.setDrawColor(150);
      doc.line(margin, y, rightX, y);

      y += 6;

      doc.setFont("helvetica", "normal");

      // ================= DATA =================
      this.rembug.forEach((item, i) => {

        if (y > pageHeight - 50) {
          doc.addPage();
          drawWatermark();
          drawHeader();
          y += 10;
        }

        // 🔥 STRIP (BARIS GENAP)
        if (i % 2 === 1) {
          doc.setFillColor(245, 245, 245); // abu soft
          doc.rect(margin, y - 4, rightX - margin, 7, "F");
        }

        doc.text(String(i + 1), margin, y);
        doc.text(item.cm_name, margin + 25, y);

        doc.text(
          String(this.thousand(item.total_setor) || 0),
          rightX,
          y,
          { align: "right" }
        );

        y += 7;
      });

      // ================= TOTAL =================
      y += 2;

      doc.setDrawColor(100);
      doc.line(margin, y, rightX, y);

      y += 7;

      doc.setFont("helvetica", "bold");

      doc.text("TOTAL", margin + 25, y);

      doc.text(
        this.thousand(this.totalDeposit),
        rightX,
        y,
        { align: "right" }
      );

      doc.setFont("helvetica", "normal");

      // ================= SIGNATURE =================
      y += 30;

      const leftSignX = margin + 25;
      const rightSignX = rightX - 25;

      // 🔥 kanan: lokasi + tanggal
      doc.setFontSize(9);
      doc.text(
        `${(this.user?.branch_name || "-").toUpperCase()}, ${tanggal.toUpperCase()}`,
        rightSignX,
        y,
        { align: "center" }
      );

      // 🔥 kiri kosong / atau bisa "Diserahkan oleh"
      doc.text(" ", leftSignX, y, { align: "center" });

      // 🔥 baris 2
      y += 7;

      doc.setFontSize(9);
      doc.text("Yang Menyerahkan", leftSignX, y, { align: "center" });
      doc.text("Yang Menerima", rightSignX, y, { align: "center" });

      // 🔥 tanda tangan
      y += 20;

      doc.addImage(this.signature, "PNG", leftSignX - 20, y - 15, 40, 20);

      doc.text(
        `(${this.user?.nama_user || '-'})`,
        leftSignX,
        y + 5,
        { align: "center" }
      );

      doc.line(rightSignX - 25, y + 5, rightSignX + 25, y + 5);

      // ================= SAVE =================
      doc.save(`setoran-${trx_code}.pdf`);

      this.sudahCetak = true;
      this.sheetCetak = false;
    },

    doLogout() {
      this.logout();
      this.$router.push("/login").catch(() => { });
    },

    getDate() {
      const today = new Date();
      const y = today.getFullYear();
      const m = String(today.getMonth() + 1).padStart(2, '0');
      const d = String(today.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },

    getDayName(dayCode) {
      const found = this.opt_hari.find(d => d.day_code === dayCode);
      return found ? found.day_name : '-';
    },

    getTodayDay() {
      const day = new Date().getDay();

      // JS: Minggu = 0 → kita ubah jadi 7
      return day === 0 ? 7 : day;
    },

    async getRembug() {
      this.$store.commit("setLoading", true);

      let payload = new FormData();
      payload.append("fa_code", this.user.fa_code);
      payload.append("hari_transaksi", this.selectedItem);
      payload.append("transaction_date", this.transaction_date);

      try {
        let req = await services.infoRembugDeposit(payload, this.user.token);

        if (req.status === 200 && Array.isArray(req.data.data)) {
          this.rembug = req.data.data;
          this.totalDeposit = this.rembug.reduce((sum, item) => {
            return sum + (item.total_setor || 0);
          }, 0);
        } else {
          this.rembug = [];
          this.totalDeposit = 0;
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: `Kumpulan tidak ditemukan`,
              color: "warning",
              position: "top",
            });
          }, 2500);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "warning",
            position: "top",
          });
        }, 2500);
      }

      this.$store.commit("setLoading", false);
    },
    async triggerGetRembug() {

      // ✅ hanya jalan kalau dua-duanya ada
      if (!this.selectedItem || !this.transaction_date) {
        return;
      }

      const key = `${this.selectedItem}_${this.transaction_date}`;

      // ✅ hindari hit berulang
      if (this._lastFetch === key) {
        return;
      }

      this._lastFetch = key;

      await this.getRembug();
      // await this.getFaDeposit();
    },
    async checkExisting(cm_code, cm_name) {
      this.loadingBtn = cm_code;

      let payload = new FormData();
      payload.append("cm_code", cm_code);
      payload.append("transaction_date", this.transaction_date);

      try {
        let req = await services.checkExisting(payload, this.user.token);

        if (req.data.status === true) {
          const jumlah = req.data.data.jumlah;

          if (jumlah > 0) {
            let req2 = await services.sendDtl(payload, this.user.token);

            if (req2.data.status === true) {
              this.$store.dispatch("showAlert", {
                show: false,
                msg: "",
              });
              setTimeout(() => {
                this.$store.dispatch("showAlert", {
                  show: true,
                  msg: `Data ${cm_name} berhasil dikirim`,
                  color: "success",
                  position: "top",
                });
              }, 2500);

              this.getRembug();
              // await this.getFaDeposit();
            }
          } else {
            this.$store.dispatch("showAlert", {
              show: false,
              msg: "",
            });
            setTimeout(() => {
              this.$store.dispatch("showAlert", {
                show: true,
                msg: `Maaf ${cm_name} tidak ada transaksi`,
                color: "info",
                position: "top",
              });
            }, 2500);
          }
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: `Terjadi kesalahan`,
            color: "error",
            position: "top",
          });
        }, 2500);
      }

      this.loadingBtn = null;
    }
  },
  mounted() {
    this.getRembug();
    // this.getFaDeposit();
  },

  watch: {
    selectedItem: 'triggerGetRembug',
    transaction_date: 'triggerGetRembug',
    sheetCetak(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.signaturePad?.resizeCanvas();
          }, 300);
        });

        // 🔥 START DETECT
        this.startDetect();
      } else {
        // stop saat ditutup
        this.stopDetect();
      }
    }
  },
};
</script>
<style scoped>
.credit-card {
  position: relative;
  /* 🔥 WAJIB */
}

.status-chip {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: auto !important;
  max-width: max-content;
  font-size: 10px;
  opacity: 0.9;
}

.signature-container canvas {
  width: 100% !important;
  height: 180px !important;
}

.sheet-modern {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
}

/* HEADER */
.sheet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.sheet-header .title {
  font-weight: 600;
  font-size: 16px !important;
}

/* CONTENT */
.sheet-content {
  max-height: 50vh;
  overflow-y: auto;
  padding: 12px 16px;
}

/* LIST */
.list-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 14px;
}

.list-row.zebra {
  background: #f7f7f7;
}

.list-row .right {
  font-weight: 500;
}

/* TOTAL */
.total-box {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
  font-size: 15px;
}

/* SIGNATURE */
.signature-box {
  margin-top: 16px;
}

.signature-box .label {
  font-size: 13px;
  margin-bottom: 6px;
}

.signature-container {
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

/* ACTION BUTTON */
.sheet-action {
  padding: 12px;
  border-top: 1px solid #eee;
}

.btn-save {
  height: 50px;
  border-radius: 14px;
  background: linear-gradient(135deg, #4CAF50, #2e7d32);
  color: white !important;
  font-weight: 600;
  text-transform: none;
}

.text-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 12px;
  text-align: center;
}

.credit-card {
  width: 100%;
  height: 200px;
  border-radius: 15px;
  padding: 20px;
  color: white;
  background-size: 300% 300%;
  background:
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.2), transparent 40%),
    radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.1), transparent 50%),
    linear-gradient(135deg, #672178, #7c2a8a, #4c1659);
  animation: gradientMove 6s linear infinite;
  filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 0.2));
  font-family: "Arial", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
}

.credit-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background: url("../images/Assetback.webp") repeat;
  background-size: 40px 40px;
  background-position: bottom right;
  opacity: 0.2;
  z-index: -1;
  /* Efek fade-out melengkung */
  -webkit-mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0) 90%);
  mask-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0) 90%);
}

.chip img {
  width: 40px;
}

.card-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-size: 26px;
  letter-spacing: 2px;
  font-weight: bold;

  text-align: center;
  width: 100%;
}

.card-warning {
  font-size: 12px;
  text-align: center;
  margin-top: -30px;
  font-weight: bold;
}

.card-details {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.card-logo {
  position: absolute;
  top: 27px;
  right: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  opacity: 0.8;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  25% {
    background-position: 50% 75%;
  }

  50% {
    background-position: 100% 50%;
  }

  75% {
    background-position: 50% 25%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* CARD */
.card-modern {
  border-radius: 18px;
  padding: 18px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

.card-modern:active {
  transform: scale(0.98);
}

/* ANGKA */
.anggota-count {
  color: #24aa24;
}

/* BUTTON */
.btn-modern {
  background: linear-gradient(135deg, #24aa4c, #bbe9bd);
  color: white;
  font-weight: 600;
  border-radius: 12px;
  text-transform: none;
  letter-spacing: 0.4px;
}

.v-icon {
  opacity: 0.8;
}

.btn-cetak-full {
  width: 100%;
  height: 52px;

  background: linear-gradient(135deg, #5c6bc0, #3949ab);
  color: white !important;

  border-radius: 14px;
  font-size: 15px;
  font-weight: 600;
  text-transform: none;

  box-shadow: 0 4px 12px rgba(63, 81, 181, 0.3);
  transition: all 0.2s ease;
}

.btn-cetak-full:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(63, 81, 181, 0.4);
}

.btn-cetak-full:active {
  transform: scale(0.98);
}
</style>
